var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { missionsRoutes } from '../../../../backend/config/missionRoute';
import { ParticipantTable } from '../../../../ui/components/participant-table';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { EmptyContentWrapper } from '@juvare/common-web-ui/EmptyContentWrapper';
import SearchIcon from '@mui/icons-material/Search';
import { Alert, Box, Button, Link as MuiLink, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { usePastApprovedShiftParticipant } from '../../shift/hooks/usePastApprovedShiftParticipant';
import { useTimeTrackingAnalytics } from '../hooks/useTimeTrackingAnalytics';
import { useTimeTrackingFilters } from '../hooks/useTimeTrackingFilters';
import { TableMobileColumns } from './TableMobileColumns';
import { TimeTrackingPageToolbar } from './TimeTrackingPageToolbar';
import { VolunteeringHours } from './VolunteeringHours';
import { VolunteeringHoursStatus } from './VolunteeringHoursStatus';
export const TimeTrackingTable = () => {
    const { fetchTimeTrackingAnalytics } = useTimeTrackingAnalytics();
    const rowsPerPageOptions = [15, 30, 45, 60];
    const { t } = useMissionsTranslation();
    const orderBy = { column: 'shiftStartTime', desc: true };
    const { applyFilter, activeFilters, clearFilters } = useTimeTrackingFilters();
    const { pastApprovedParticipations: userShiftParticipation, isLoading, fetchParticipants, handleAddHours, handleDeleteHours, } = usePastApprovedShiftParticipant({
        orderBy,
        appliedFilters: activeFilters,
    });
    const handleSubmitHoursAndAddTotal = (addHoursParams) => __awaiter(void 0, void 0, void 0, function* () {
        yield handleAddHours(addHoursParams);
        yield fetchParticipants();
        yield fetchTimeTrackingAnalytics();
    });
    const upMdScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));
    return (React.createElement(ParticipantTable, { allRows: userShiftParticipation.shiftParticipants.rows, columns: [
            {
                value: 'shiftStartTime',
                label: 'Shift Date',
                render: (row, columnValues) => {
                    const shiftDate = new Date(row.columns.shiftStartTime);
                    return upMdScreen ? (React.createElement(Typography, { key: row.id, variant: 'body2' }, t('dateString', { value: shiftDate }))) : (React.createElement(TableMobileColumns, { key: row.id + '-shift-start', row: row, columnValues: columnValues, handleAddHours: handleSubmitHoursAndAddTotal }));
                },
                maxWidth: 104,
            },
            {
                value: 'missionName',
                label: 'Mission Name',
                render: (row) => upMdScreen ? (React.createElement(Typography, { key: row.id + '-mission', variant: 'body2', sx: {
                        wordBreak: 'break-word',
                    } }, row.columns.missionName)) : undefined,
                maxWidth: 536,
            },
            {
                value: 'positionName',
                label: 'Position',
                render: (row) => upMdScreen ? (React.createElement(Typography, { key: row.id + '-position', variant: 'body2', sx: {
                        wordBreak: 'break-word',
                    } }, row.columns.positionName)) : undefined,
                maxWidth: 232,
            },
            {
                value: 'hours',
                label: 'Hours',
                render: (row) => upMdScreen ? (React.createElement(VolunteeringHours, { shiftParticipantId: row.id, hoursStatus: row.columns.hoursStatus, hours: row.columns.hours })) : undefined,
                maxWidth: 232,
            },
            {
                value: 'status',
                label: 'Status',
                render: (row) => upMdScreen ? (React.createElement(VolunteeringHoursStatus, { key: row.id + '-status', participation: row, onAddHours: handleSubmitHoursAndAddTotal })) : undefined,
                maxWidth: 124,
            },
        ], rowsPerPageOptions: rowsPerPageOptions, readonly: false, showTableBorder: true, showToolbarBorder: false, showTableHead: upMdScreen, totalRows: userShiftParticipation.shiftParticipants.total, toolbar: (params) => (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
            React.createElement(TimeTrackingPageToolbar, { selectedRowIds: params.selectedRows.map((row) => row.id), disableDelete: params.selectedRows.length === 0 || params.selectedRows.some((row) => Number.isInteger(row.columns.hours)), onDeleteHours: (deleteHoursParams) => __awaiter(void 0, void 0, void 0, function* () {
                    yield handleDeleteHours(deleteHoursParams);
                    yield fetchParticipants();
                    params.handleSelectReset(deleteHoursParams.participationIds);
                }), onFilterChange: applyFilter, onClearFilters: clearFilters }),
            userShiftParticipation.shiftsMissingHours > 0 && (React.createElement(Box, { sx: { pb: { sm: 2, md: 1 } } },
                React.createElement(Alert, { severity: 'warning' }, t('timeTracking.missingHours', { shiftsMissingHours: userShiftParticipation.shiftsMissingHours })))))), emptyTableView: React.createElement(EmptyContentWrapper, { description: t('timeTracking.noCompletedMissionShifts') },
            React.createElement(MuiLink, { component: Link, to: `../${missionsRoutes.root}`, underline: 'none' },
                React.createElement(Button, { startIcon: React.createElement(SearchIcon, null), variant: 'contained' }, t('missions.browseMissions')))), isLoading: isLoading }));
};
